import { useState } from "react";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";

const EMPTY = { name: "", email: "", phone: "", organization: "", event_name: "", event_date: "", location: "", audience_size: "", message: "" };
const FIELDS = [
  ["name", "Your name", "text", true], ["email", "Email", "email", true], ["phone", "Phone", "tel"],
  ["organization", "Church / organization", "text", true], ["event_name", "Event name", "text"], ["event_date", "Event date", "date"],
  ["location", "City / location", "text"], ["audience_size", "Expected audience size", "text"],
];

export default function SpeakingForm() {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/speaking", f);
      setSent(true);
      setF(EMPTY);
    } catch (er) { toast.error(errMsg(er)); }
    setBusy(false);
  };
  if (sent)
    return (
      <div className="card-lux p-10 text-center" data-testid="speaking-success">
        <CheckCircle2 className="mx-auto text-[#D4AF37]" size={44} />
        <p className="font-serif text-2xl font-semibold text-white mt-4">Thank you. Your invitation has been sent.</p>
        <p className="text-slate-400 mt-2">Todd's team will review it and get back to you soon.</p>
        <button onClick={() => setSent(false)} className="btn-outline mt-6" data-testid="speaking-send-another-btn">Send another</button>
      </div>
    );
  return (
    <form onSubmit={submit} className="card-lux p-6 sm:p-10 grid sm:grid-cols-2 gap-5" data-testid="speaking-form">
      {FIELDS.map(([k, label, type, req]) => (
        <div key={k}>
          <label className="label" htmlFor={`sp-${k}`}>{label}{req && " *"}</label>
          <input id={`sp-${k}`} type={type} required={req} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} className="field" data-testid={`speaking-${k}-input`} />
        </div>
      ))}
      <div className="sm:col-span-2">
        <label className="label" htmlFor="sp-message">Tell us about your event</label>
        <textarea id="sp-message" rows={5} value={f.message} onChange={(e) => setF({ ...f, message: e.target.value })} className="field" data-testid="speaking-message-input" />
      </div>
      <div className="sm:col-span-2">
        <button disabled={busy} className="btn-gold" data-testid="speaking-submit-btn">{busy ? "Sending..." : "Send invitation"}</button>
      </div>
    </form>
  );
}
